import { theme } from '@frontend/theme';
import { HeaderBaseProps } from '../types';

export const HeaderRoot = ({ children, css, noBorder, ...rest }: HeaderBaseProps) => {
  return (
    <header
      css={[
        {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          padding: `${theme.spacing(2)}`,
        },
        noBorder && { borderBottom: 0 },
        css,
      ]}
      {...rest}
    >
      {children}
    </header>
  );
};
